import { createI18n } from 'vue-i18n';
import messages from 'zone/locales/common.json';

// The vue-i18n instance of the Zone stack. Every component carries its own strings in an
// `<i18n lang="json">` block (`{ "en": { … } }`) and reads them with vue-i18n's `useI18n()`; the
// shared words of `locales/common.json` are the global messages every block falls back to, so
// `t('cancel')` works in any component with nothing to declare. The fallback warnings are off because
// that fallback is the design; a key missing everywhere, or a block repeating a shared key, is an
// ESLint error (@intlify/vue-i18n). Another shared file in `locales/` is pulled in where it is used,
// `<i18n lang="json" src="zone/locales/<file>.json">`. @intlify/unplugin-vue-i18n
// (config/vite/plugins/index.ts) compiles the blocks and, given VITE_ZONE_LANG, keeps only that
// language: one build per language.
const locale = import.meta.env.VITE_ZONE_LANG || 'en';

export const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: 'en',
  fallbackWarn: false,
  missingWarn: false,
  messages,
});

// A vue-i18n composer over `messages` alone, for a JS module with copy of its own (a rules file).
export const createScopedI18n = (messages) => createI18n({ legacy: false, locale, fallbackLocale: 'en', messages }).global;
